import React from "react";
import logo from "../../../assets/kangaroo/kangrooooo.png";
import { Col, Container, Row } from "reactstrap";
import fbIcon from "../../../assets/kangaroo/facebookIcon.png";
import inIcon from "../../../assets/kangaroo/instagramIcon.png";
import tiktokIcon from "../../../assets/kangaroo/tiktokIcon.png";
import linkedinIcon from "../../../assets/kangaroo/linkedinIcon.png";
import twitterIcon from "../../../assets/kangaroo/twitterIcon.png";
import { hover, motion } from 'framer-motion';
import "../../../Homepage/Component/Homepage.css";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div
      className="main-container "
      style={{ backgroundColor: "#7D178F", paddingTop: "72px",  paddingBottom: "3rem" }}
    >
      <Container className="w-100">
        {/* Header Section */}

        <Row className="mb-5 align-items-center">
          <Col xs={12} md={4} className="mb-3 mb-md-0">
            <img
              src={logo}
              alt="KEF Logo"
              className="img-fluid"
              style={{ maxHeight: "106px" }}
            />
          </Col>
          <Col lg={2}></Col>
          <Col sm={12} md={6} className="d-flex justify-content-md-end gap-3 " style={{marginBottom:"2.5rem"}}>
            <motion.button
  className="rounded-pill border border-white navbar-btn-font"
  style={{
    backgroundColor: "transparent",
    width: "235px",
    height: "45px",
    position: "relative",
    overflow: "hidden",
    cursor: "pointer",
  }}
  whileHover="hover"
>
  <motion.div
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "#FF6A17",
      zIndex: 0,
    }}
    initial={{ x: "-100%" }}
    variants={{
      hover: { x: 0 }
    }}
    transition={{
      duration: 0.5,
      ease: "easeInOut"
    }}
  />
  <motion.span 
    style={{ position: "relative", zIndex: 1 }}
    initial={{ color: "#fff" }}
    variants={{
      hover: { 
        color: "#fff",
        transition: {
          duration: 0.5
        }
      }
    }}
  >
    CONTACT US
  </motion.span>
</motion.button>
            {/* <button
  className="rounded-pill navbar-btn-font py-2 px-4"
  style={{
    width: "235px",
    height: "45px",
    border: "0px",
    position: "relative",
    background: "#FF6A17",
    overflow: "hidden",
  }}
  onMouseEnter={(e) => {
    const overlay = e.currentTarget.querySelector('.gradient-overlay');
    if (overlay) overlay.style.opacity = "1";
  }}
  onMouseLeave={(e) => {
    const overlay = e.currentTarget.querySelector('.gradient-overlay');
    if (overlay) overlay.style.opacity = "0";
  }}
>
  <span
    className="gradient-overlay"
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "linear-gradient(to right, #83168F , #D40B84)",
      opacity: 0,
      transition: "opacity 0.5s ease",
      pointerEvents: "none",
    }}
  />
  <span style={{ position: "relative", zIndex: 1 }}>GET FREE COUNSELING</span>
</button> */}

         <motion.button
  className="rounded-pill navbar-btn-font py-2 px-4"
  style={{
    width: "265px",
    height: "45px",
    border: "0px",
    position: "relative",
    background: "#FF6A17",
    overflow: "hidden",
    cursor: "pointer",
  }}
  whileHover="hover"
>
  <motion.div
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "linear-gradient(to right, #83168F, #D40B84)",
      zIndex: 0,
    }}
    initial={{ x: "-100%" }}
    variants={{
      hover: { x: 0 }
    }}
    transition={{
      duration: 0.5,
      ease: "easeInOut"
    }}
  />
  <motion.span 
    style={{ position: "relative", zIndex: 1 }}
    initial={{ color: "#fff" }}
    variants={{
      hover: { 
        color: "#fff",
        transition: {
          duration: 0.5
        }
      }
    }}
  >
    GET FREE COUNSELING
  </motion.span>
</motion.button>
          </Col>
          
        </Row>

        {/* Links Section */}
        <Row className="mb-5">
 
 
  

  <Col xs={12} sm={6} md={3} className="mb-4 mb-md-0">
    <h5 className="mb-3 navbar-btn-font">USEFUL LINKS</h5>
    <p className="mb-2 footer-item-font" style={{ cursor: "pointer" }}>
      IELTS Band Score Calculator
    </p>
    <p className="mb-2 footer-item-font" style={{ cursor: "pointer" }}>
      PTE Score Calculator
    </p>
    <p className="mb-2 footer-item-font" style={{ cursor: "pointer" }}>
      NEB to GPA Calculator
    </p>
    <p className="mb-2 footer-item-font" style={{ cursor: "pointer" }}>
      SEE to GPE Calculator
    </p>
    <p className="mb-2 footer-item-font" style={{ cursor: "pointer" }}>
      GPA to Percentage Calculator
    </p>
  </Col>
   <Col xs={12} sm={6} md={3} className="mb-4 mb-md-0">
    <h5 className="mb-3 navbar-btn-font">ABOUT KEF</h5>
    <p className="mb-2 footer-item-font" style={{ cursor: "pointer" }}>
      Who we are
    </p>
    <p className="mb-2 footer-item-font" style={{ cursor: "pointer" }}>
      Milestone
    </p>
    <p className="mb-2 footer-item-font" style={{ cursor: "pointer" }}>
      Our Certification
    </p>
    <p className="mb-2 footer-item-font" style={{ cursor: "pointer" }}>
      Our Partners
    </p>
    <p className="mb-2 footer-item-font" style={{ cursor: "pointer" }}>
      Message from CEO
    </p>
    <p className="mb-2 footer-item-font" style={{ cursor: "pointer" }}>
      Career
    </p>
  </Col>


  <Col xs={12} sm={6} md={3} className="mb-4 mb-md-0">
    <h5 className="mb-3 navbar-btn-font">STUDY ABROAD</h5>
    <p className="mb-2 footer-item-font" style={{ cursor: "pointer" }}>
      Institutions We Represent
    </p>
    <p className="mb-2 footer-item-font" style={{ cursor: "pointer" }}>
      Study Abroad Facts
    </p>
    <p className="mb-2 footer-item-font" style={{ cursor: "pointer" }}>
      Sample Documents
    </p>
    <p className="mb-2 footer-item-font" style={{ cursor: "pointer" }}>
      Statement of Purposes (SOP)
    </p>
    <p className="mb-2 footer-item-font" style={{ cursor: "pointer" }}>
      Interview Preparation Guidelines
    </p>
    <p className="mb-2 footer-item-font" style={{ cursor: "pointer" }}>
      Upcoming Events
    </p>
    <p className="mb-2 footer-item-font" style={{ cursor: "pointer" }}>
      OSHC
    </p>
  </Col>
   <Col xs={12} sm={6} md={3} className="mb-4 mb-md-0">
    <h5 className="mb-3 navbar-btn-font">QUICK LINKS</h5>
    <p className="mb-2 footer-item-font" style={{ cursor: "pointer" }}>
      Testimonial
    </p>
    <p className="mb-2 footer-item-font" style={{ cursor: "pointer" }}>
      Upcoming Events
    </p>
    <p className="mb-2 footer-item-font" style={{ cursor: "pointer" }}>
      Newsletter
    </p>
  </Col>
</Row>

        {/* Divider */}
        <hr className="border border-white mb-4" />

        {/* Social Media Icons */}
        <Row className="mb-4">
          <Col
            xs={12}
            className="d-flex justify-content-center justify-content-md-start gap-3"

          >
            <Link to={"https://www.facebook.com/KangarooEdu/"}>
            
            <img
              src={fbIcon}
              style={{ width: "38px", height: "38px" }}
              alt=""
            />
            </Link>

            <Link to="https://www.instagram.com/kangaroo_education_foundation/?hl=en">
            
            <img
              src={inIcon}
              style={{ width: "38px", height: "38px" }}
              alt=""
            />
            </Link>

            <Link to="https://www.tiktok.com/@kangaroo.edu?lang=en">
            
            <img
              src={tiktokIcon}
              style={{ width: "38px", height: "38px" }}
              alt=""
            />
            </Link>


            <Link to="https://np.linkedin.com/company/kangaroo-education-foundation">
            
            <img
              src={linkedinIcon}
              style={{ width: "38px", height: "38px" }}
              alt=""
            />
            </Link>

            <img
              src={twitterIcon}
              style={{ width: "38px", height: "38px" }}
              alt=""
            />
          </Col>
        </Row>

        {/* Footer Bottom */}
        <Row className="align-items-center" >
          <Col
            xs={12}
            md={6}
            className="mb-2 mb-md-0 text-center text-md-start"
          >
            <p className="mb-0 text-white" style={{ fontSize: "0.9rem" }}>
              Copyright © 2025 Kangaroo Education Foundation
            </p>
          </Col>
        <Col xs={12} md={6} className="d-flex justify-content-center justify-content-md-end gap-5">
  <p className="mb-0 text-white" style={{ fontSize: "0.9rem", cursor: "pointer" }}>
    Privacy Policy
  </p>
  <p className="mb-0 text-white" style={{ fontSize: "0.9rem", cursor: "pointer" }}>
    Terms and Conditions
  </p>
</Col>

        </Row>
      </Container>
    </div>
  );
};

export default Footer;
